import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const StMegaScreenerSection = styled(Box)(({ theme }) => ({
  paddingTop: '2px',
  paddingBottom: '28px',
  paddingInline: '24px',
  paddingLeft: '24px',
  paddingRight: '24px',
  [theme.breakpoints.up(800)]: {
    paddingTop: '2px',
    paddingBottom: 0,
    paddingRight: 0,
    paddingInline: 0,
    paddingLeft: theme.spacing(8),
  },
}));
